import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormSubmittedEvent,
  ReactiveFormsModule,
} from '@angular/forms';
import { filter } from 'rxjs';
import { EventEmitter } from 'stream';

@Component({
  selector: 'app-formcontrol',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './formcontrol.component.html',
  styleUrl: './formcontrol.component.scss',
})
export class FormControlComponent implements OnInit, OnDestroy {
  @Input() Class: string[] = ['form-control', 'form-control-sm'];
  @Input({ alias: 'a-formcontrol' }) FormControl!: FormControl<string | number | null>; //since it's required and typed we can safely assume a value must be passed in.
  @Input({ alias: 'a-formcontrol-name' }) FormControlName?: string;
  @Input({ alias: 'a-validation-messages' }) ValidationMessages?: {
    validationName: string;
    validationMessage: string;
    }[];
    @Input({ alias: 'a-formcontrol-type' }) FormControlType?: string;
  formSubmitted: boolean = false;
  formGroup: Partial<typeof this.FormControl.parent> = null;
  constructor() {}
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    if (!(this.FormControl instanceof FormControl)) {
      throw new Error('a-formcontrol must be an instance of FormControl');
    }

    this.FormControl.events
      .pipe(filter((event) => event instanceof FormSubmittedEvent))
      .subscribe((event) => {
        this.formSubmitted = true;
      });

    this.formGroup = this.FormControl.parent;
  }
}
